import { Button, CircularProgress, Typography } from '@mui/material'
import { useSeparateWallTool } from '../../../visualization/tools/useSeparateWallTool'

const ObjectSeparateButton = () => {
  const [elementToSeparate, isSeparable, isLoading, separateElement] =
    useSeparateWallTool()

  if (!elementToSeparate) {
    return null
  }

  const component = (
    <Button
      disableRipple
      size='small'
      disabled={!isSeparable}
      onClick={separateElement}
      sx={{
        textTransform: 'none',
        background: '#ffffff',
        height: '32px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          color: '#04002E',
          fontSize: '0.76rem',
          textAlign: 'center',
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'normal',
          textWrap: 'nowrap',
          visibility: isLoading ? 'hidden' : 'visible',
        }}
      >
        Separate Walls
      </Typography>
      <CircularProgress
        size={20}
        sx={{
          position: 'absolute',
          visibility: isLoading ? 'visible' : 'hidden',
        }}
      />
    </Button>
  )

  return {
    component,
    meshes: [elementToSeparate],
  }
}

export default ObjectSeparateButton
